module.exports = __webpack_public_path__ + "img/mine.a5d53568.png";